<template lang="html">
  <div>
    <v-app-bar app flat color="white" height="72">
      <v-container class="px-0">
        <v-row>
          <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
            <div class="d-flex align-center">
              <v-btn icon width="40" height="40" class="mr-2" @click="goBack()">
                <v-icon>
                  mdi-arrow-left
                </v-icon>
              </v-btn>
              <div class="title-page-text">
                {{ $t('v2.add_voucher') }}
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
    <v-container class="pt-0">
      <v-row>
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pt-0">
          <div class="mt-2">
            <v-text-field
              color="olbrand"
              prepend-inner-icon="mdi-magnify"
              :placeholder="$t('v2.enter_voucher_code')"
              clearable
              hide-details
              rounded
              outlined
              height="40"
              dense
              @blur="is_voucher_focus = false"
              @focus="is_voucher_focus = true"
              @input="searchVoucher"
            />
          </div>
          <div v-if="!is_voucher_searching && !is_voucher_focus && vouchers.length === 0" class="mt-8">
            <div class="text-center">
              <div class="mb-2">
                <svg width="90" height="90" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="6" y="30" width="78" height="36" rx="6" fill="#767676" />
                  <rect y="24" width="90" height="38" rx="6" fill="#CECECE" />
                  <rect x="7" y="30" width="34" height="7" rx="3.5" fill="#767676" />
                  <rect x="7" y="42" width="34" height="2" rx="1" fill="#767676" />
                  <path d="M58 30H78C81.3137 30 84 32.6863 84 36V50C84 53.3137 81.3137 56 78 56H58V30Z" fill="#767676" />
                </svg>
              </div>
              <div class="font-18 font-weight-700">
                {{ $t('v2.no_vouchers') }}
              </div>
            </div>
          </div>
          <div v-else-if="!is_voucher_searching && is_voucher_focus" class="mt-8">
            <div class="text-center">
              <img src="@/assets/images/v2/img/no_data_item.png" alt="No data" width="300px" class="mb-2">
              <div class="font-18 font-weight-700">
                {{ $t('v2.enter_voucher_code') }}
              </div>
            </div>
          </div>
          <template v-else-if="!is_voucher_searching && !is_voucher_focus && voucher_search || is_voucher_searching && voucher_search">
            <div class="mt-10">
              <div class="font-18 font-weight-700">
                {{ $t('v2.your_vouchers') }}
              </div>
            </div>
            <div v-scroll="onScrollItem" class="list-with-border">
              <div v-for="(voucher, x) in vouchers" :key="x" class="list-item-with-border flex-image py-6 px-4 cursor-pointer" @click="showDiscountDetail(voucher.id)">
                <div class="flex-image-avatar mr-2">
                  <img src="@/assets/images/v2/img/icon_discount.png" alt="Voucher">
                </div>
                <div class="flex-image-content">
                  <div class="flex-image-content-text font-14 font-weight-600 ol-black line-height-normal">
                    {{ voucher.title }}
                  </div>
                  <div class="ol-grey-content flex-image-content-text font-12 font-weight-400 line-height-normal">
                    {{ voucher.fexpiry_date }}
                  </div>
                </div>
                <!-- <div>
                  <v-btn color="primary" height="37" :disabled="!voucher.can_use" class="white--text text-none elevation-0 font-14 br-5 letter-spacing-normal" @click.stop="hitVoucher(voucher.id)">
                    {{ $t('v2.use') }}
                  </v-btn>
                </div> -->
              </div>
            </div>
          </template>
          <div v-else-if="is_voucher_searching && vouchers.length === 0" class="mt-8">
            <div class="text-center">
              <div class="mb-2">
                <svg width="90" height="90" viewBox="0 0 90 90" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="6" y="30" width="78" height="36" rx="6" fill="#767676" />
                  <rect y="24" width="90" height="38" rx="6" fill="#CECECE" />
                  <rect x="7" y="30" width="34" height="7" rx="3.5" fill="#767676" />
                  <rect x="7" y="42" width="34" height="2" rx="1" fill="#767676" />
                  <path d="M58 30H78C81.3137 30 84 32.6863 84 36V50C84 53.3137 81.3137 56 78 56H58V30Z" fill="#767676" />
                </svg>
              </div>
              <div class="font-18 font-weight-700">
                {{ $t('v2.voucher_not_found') }}
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-bottom-sheet v-model="dialog.voucher_detail" content-class="dialog-icon">
      <div class="position-relative">
        <v-btn fab small color="white" class="btn-close-dialog-icon" @click="dialog.voucher_detail = false">
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </div>
      <v-sheet class="sheet-border">
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
              <template v-if="!$isEmpty(voucher_detail)">
                <div class="py-2 mb-8">
                  <div class="mt-2 font-18 font-weight-700">
                    {{ voucher_detail.title }}
                  </div>
                  <div v-if="voucher_detail.fexpiry_date" class="font-12 font-weight-400 ol-grey-content">
                    {{ $t('v2.expire_on') }} {{ voucher_detail.fexpiry_date }}
                  </div>
                </div>
                <div class="pa-4 br-8 bg-grey" :style="{ marginBottom: !voucher_detail.can_use ? '150px' : '64px' }">
                  <div class="font-weight-600 mb-2">
                    {{ $t('v2.terms_and_conditions') }}
                  </div>
                  <div class="font-14" v-html="voucher_detail.discount_description" />
                </div>
                <div class="section-bottom absolute white ol-min-elevation-2">
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="py-0">
                        <div v-if="!voucher_detail.can_use" class="mb-3">
                          <div class="flex-image pa-4 bg-orange-soft br-8">
                            <div class="mr-2">
                              <v-icon size="24" color="olorange">
                                mdi-alert-outline
                              </v-icon>
                            </div>
                            <div class="flex-image-content">
                              <div class="flex-image-content-text font-14 font-weight-600 ol-black">
                                {{ $t('v2.voucher_does_not_meet_the_terms_and_conditions') }}
                              </div>
                            </div>
                          </div>
                        </div>
                        <v-btn v-if="!$isEmpty(cart.discount_detail)" block color="white" height="40" class="text-none br-5 letter-spacing-normal font-weight-700 ol-red ol-elevation-1" @click="deleteVoucher(voucher_detail.id)">
                          {{ $t('v2.delete_voucher') }}
                        </v-btn>
                        <v-btn v-else block color="primary" :disabled="!voucher_detail.can_use" height="40" class="text-none br-5 letter-spacing-normal font-weight-700" @click="hitVoucher(voucher_detail.id)">
                          {{ $t('v2.use_voucher') }}
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </div>
              </template>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>
<script>
import { debounce } from 'debounce'
import {
  hitDiscount as hitDataDiscount,
  getDataValidate as getDataDiscount,
  getDataDetailValidate as getDataDetailDiscount
} from '@/api/discount'
export default {
  data() {
    return {
      voucher_search: true,
      is_voucher_searching: false,
      is_voucher_focus: false,
      dialog: {
        voucher_detail: false
      },
      voucher_detail: {},
      vouchers: [],
      params: {
        page: 1,
        per_page: 10,
        search_column: [],
        search_operator: [],
        search_text: []
      },
      settingScroll: false,
      cart: {}
    }
  },
  computed: {
    dataParams() {
      var params = {
        page: this.params.page,
        per_page: this.params.per_page
      }
      if (this.params.search_column.length > 0) {
        params.search_column = this.params.search_column
        params.search_operator = this.params.search_operator
        params.search_text = this.params.search_text
      }
      return params
    }
  },
  mounted() {
    const LOCAL_DATA_CART = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_cart')
    if (LOCAL_DATA_CART) {
      this.cart = JSON.parse(LOCAL_DATA_CART)
    }
    this.fetchVouchers()
  },
  methods: {
    goBack() {
      this.$router.push({ name: '_checkout' }).catch(() => {})
    },
    onScrollItem() {
      this.scrollLoad()
    },
    scrollLoad: debounce(async function() {
      if (this.settingScroll === false) {
        if ((window.innerHeight + window.scrollY + 100) >= document.body.offsetHeight) {
          this.fetchVouchers()
        }
      }
    }, 500),
    async fetchVouchers() {
      let remark = ''
      if (this.$store.state.selected_type === 'OL-TAKE-AWAY') {
        remark = 'use_take_away'
      } else if (this.$store.state.selected_type === 'DELIVERY') {
        remark = 'use_delivery'
      } else if (this.$store.state.selected_type === 'DINE-IN') {
        remark = 'use_dine_in'
      } else if (this.$store.state.selected_type === 'RESERVATION') {
        remark = 'use_reservation'
      }
      const index = this.params.search_column.findIndex(function(data) {
        return data === remark
      })
      if (index === -1) {
        this.params.search_column.push(remark)
        this.params.search_operator.push('=')
        this.params.search_text.push(1)
      } else {
        this.params.search_column[index] = remark
        this.params.search_operator[index] = '='
        this.params.search_text[index] = 1
      }
      try {
        const { data } = await getDataDiscount(this.cart, this.dataParams)
        this.settingScroll = (data.data.length < this.params.per_page)
        this.voucher_search = data.meta.total > 0
        for (var i in data.data) {
          this.vouchers.push(data.data[i])
        }
        this.params.page++
      } catch (e) {
        this.vouchers = []
        if (e.statusCode === 401) {
          this.$store.dispatch('fetchToken')
        } else if (e.statusCode !== 404) {
          this.$store.state.show_error = true
          this.$store.state.error_message = e.string
          this.$store.state.error_type = e.statusCode
        }
        this.voucher_search = false
      }
    },
    searchVoucher: debounce(async function(val) {
      this.params.page = 1
      this.vouchers = []
      this.params.search_column = []
      this.params.search_operator = []
      this.params.search_text = []
      this.params.search_column.push('code')
      this.params.search_operator.push('like')
      this.params.search_text.push(val || '')
      this.is_voucher_searching = !(val = !val)
      this.fetchVouchers()
    }, 1000),
    async hitVoucher(id) {
      const data_hit = { ...this.cart }
      data_hit.discount_id = id
      data_hit.remark = this.$store.state.selected_type
      this.$delete(this.cart, 'discount_voucher_id')
      this.$delete(this.cart, 'discount_detail')
      try {
        const { data } = await hitDataDiscount(data_hit)
        this.cart.discount_voucher_id = id
        this.$set(this.cart, 'discount_detail', data.data)
        await this.$store.dispatch('saveCartV2', this.cart)
        this.$router.push({ name: '_checkout' }).catch(() => {})
        this.$store.state.show_error = true
        this.$store.state.error_message = this.$t('v2.discount_successfully_used')
        this.$store.state.error_type = 200
      } catch (e) {
        if (e.statusCode === 401) {
          this.$store.dispatch('fetchToken')
        } else {
          this.$store.state.show_error = true
          this.$store.state.error_message = e.string
          this.$store.state.error_type = e.statusCode
        }
      }
    },
    async showDiscountDetail(id) {
      this.voucher_detail = {}
      this.dialog.voucher_detail = true
      let remark = ''
      if (this.$store.state.selected_type === 'OL-TAKE-AWAY') {
        remark = 'use_take_away'
      } else if (this.$store.state.selected_type === 'DELIVERY') {
        remark = 'use_delivery'
      } else if (this.$store.state.selected_type === 'DINE-IN') {
        remark = 'use_dine_in'
      } else if (this.$store.state.selected_type === 'RESERVATION') {
        remark = 'use_reservation'
      }
      const index = this.params.search_column.findIndex(function(data) {
        return data === remark
      })
      if (index === -1) {
        this.params.search_column.push(remark)
        this.params.search_operator.push('=')
        this.params.search_text.push(1)
      } else {
        this.params.search_column[index] = remark
        this.params.search_operator[index] = '='
        this.params.search_text[index] = 1
      }
      try {
        const { data } = await getDataDetailDiscount(id, this.cart, this.dataParams)
        this.$store.state.loading_axios = false
        this.voucher_detail = data.data
      } catch (e) {
        this.$store.state.show_error = true
        this.$store.state.error_message = e.string
        this.$store.state.error_type = e.statusCode
      }
    }
  }
}
</script>
